import EventEmitter from './EventEmitter';
import {Ticker_state} from '../../@types/shared';

const DRAG_DECREASE: number = 0.5;//dragの加速度減衰率

const frameMS = 1000 / 60;

export default new class Ticker extends EventEmitter {

  public e = {
    update: 'update',
  };

  _state: Ticker_state = {
    startTime: Date.now(),
    currentTime: Date.now(),
    tickedTime: 0,
    fps: 60,
    fpsAverage: 60,
    frameStretch: 1,
  };
  _fpsHistory: number[] = [];
  _bindedUpdateHdl: Function;
  _timeouts: { fn: Function, endTime: number }[] = [];

  constructor() {
    super();
  }

  setup() {
    this._bindedUpdateHdl = this._updateHdl.bind(this);
    this._updateHdl();
  }

  get state(): Ticker_state {
    return this._state;
  }

  _updateHdl() {
    const now: number = Date.now();
    this._state.tickedTime = now - this._state.currentTime;
    this._state.currentTime = now;
    this._state.elapsedTime = now - this._state.startTime;
    this._state.updateElapsedTime = this._state.updatePrevTime ? (now - this._state.updatePrevTime) : frameMS;//60fps
    this._state.updatePrevTime = now;
    this._state.fps = Math.min(60, 1000 / this._state.updateElapsedTime);
    this._state.frameStretch = Math.max(0, this._state.updateElapsedTime / frameMS);
    this._fpsHistory.push(this._state.fps);
    if(this._fpsHistory.length > 60) this._fpsHistory = this._fpsHistory.slice(-60);
    let totalFPS = 0;
    this._fpsHistory.forEach(fps => totalFPS += fps);
    this._state.fpsAverage = totalFPS / this._fpsHistory.length;

    this._timeouts.forEach((item, i) => {
      if (item && (now >= item.endTime)) {
        item.fn();
        this._timeouts[i] = null;
      }
    });

    this.emit(this.e.update);
    window.requestAnimationFrame(<any>this._bindedUpdateHdl);
  }

  //通常のsetTimeoutだとうまくdelayが効かない時用のタイムアウト
  public setTimeout(fn: Function, duration: number): number {
    this._timeouts.push({fn: fn, endTime: this._state.currentTime + duration});
    return this._timeouts.length - 1;
  }

  public clearTimeout(timeoutId: number) {
    this._timeouts[timeoutId] = null;
  }

}();
